'use client';

import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import { SignUpTemplate } from '@weareconceptstudio/account';
import config from '@/helpers/_config';

const SignUp = () => {
	const searchParams = useSearchParams();

	const redirectParam = useMemo(() => (searchParams.has('r') ? `?r=${searchParams.get('r')}` : ''), [searchParams]);

	return (
		<SignUpTemplate
			formFields={config.package.signUpFormFields}
			signInUrl={`/login${redirectParam}`}
			privatePolicyUrl={config.routes.privacyAndReturns.path}
		/>
	);
};

export default SignUp;
